import { includes } from 'lodash'
import Vue from 'vue'
import auth from 'utils/auth'
import store from 'vx/store'
import { APP_LOADING } from 'vx/mutations'
import pace from './pace'
import abilities from './abilities'

export default (router) => {

  //router.beforeEach(pace)

  router.beforeEach((to, from, next) => {
    Vue.prototype.$previousRoute = from
    //Vue.prototype.$user = new UserDecorator()

    const defineAuthorizedUser = () => {
      Vue.prototype.$user = store.getters['user/authorized']
    }

    if (Vue.prototype.$echo) {
      localStorage.setItem('x-socket-id', Vue.prototype.$echo.socketId());
    }

    const redirectBasedOnAuthorization = () => {
      let user = store.getters['user/authorized']

      if (includes(['login'], to.name)) {
        next({ path: '/dashboard' })
      } else {
        next()
      }
    }

    // If route requires authentication attempt to authorize the logged in user
    // via their token if we do not have an authorized user already.
    if (to.matched.some((route) => route.meta.requiresAuth === true)) {
      const redirectToLogin = () => {
        if (to.path === '/') {
          next({ name: 'auth.login' })
        } else {
          next({ name: 'auth.login', query: { redirect: to.path } })
        }
      }

      auth.fromToken()
        .then(defineAuthorizedUser)
        .then(redirectBasedOnAuthorization)
        .then(() => {
          store.commit(`settings/app/${APP_LOADING}`, false)
        })
        .catch(redirectToLogin)

      // If the route does not require authentication then we'll still attempt to
      // authorize the user via any token and if they are authorized we'll send
      // them back to a determined page. Happens when they hit the login route
      // even though you're already logged in. If we can't log them in then
      // we'll simply continue on to what would most likely be the login.
    } else {
      auth.fromToken()
        .then(defineAuthorizedUser)
        .then(redirectBasedOnAuthorization)
        .then(() => {
          store.commit(`settings/app/${APP_LOADING}`, false)
        })
        .catch(() => {
          next()
        })
    }
  })
  router.beforeEach(abilities)
}
